import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { isBillingOnlyTerritoryViewer } from '&/features/billing/paths';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/')({
  beforeLoad: ({ context, params }): void => {
    if (!context.permissions.isReady) {
      return;
    }
    const { hasPermission } = context.permissions;
    if (!hasPermission('territories:list')) {
      throw redirect({
        params: { territoryId: params.territoryId },
        to: '/settings/territories/$territoryId/locations',
      });
    }
    // SWOOP-430: a Billing Officer holds `territories:list` (to reach Settings › Territories) but has no business
    // on the General tab — send it to its only tab, Billing. Tenant/Territory Admin keep General (they hold
    // `territories:manage`/`:edit`); the `billing-settings:list` half keeps this from looping.
    if (isBillingOnlyTerritoryViewer(hasPermission)) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId/billing' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/territories/pages/territory-general-page')),
  staticData: { titleKey: 'general' },
});
